import React from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import Feedback from "react-bootstrap/Feedback";
import {nlToBr} from "../../utils/Strings";
import {GlobalContext} from "../../GlobalContext";

export default class ChangePasswordForm extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            validated: false,
            errorMessage: '',
            form: {
                currentPassword: '',
                newPassword1: '',
                newPassword2: ''
            }
        }
    }

    handleSubmit = () => {
        if (this.validate()) {
            this.context.apiRequest("POST", "/my/password", this.state.form)
                .then(resp => {
                    if (resp.status === 200) {
                        this.props.onSuccess();
                    } else if (resp.message) {
                        this.setState({errorMessage: resp.message});
                    }
                });
        }
    }

    validate = () => {
        this.setState({validated: false, errorMessage: ''});
        let valid = true;
        let errorMessage = "";
        if(this.state.form.newPassword1 !== this.state.form.newPassword2) {
            errorMessage += "New password and confirmation don't match.\n";
            valid = false;
        }
        if (this.state.form.currentPassword === this.state.form.newPassword1) {
            errorMessage += "New password can't be the same as previous password.\n";
            valid = false;
        }
        let form = document.getElementById('password-form');
        valid &= form.checkValidity();
        this.setState({validated: true, errorMessage});
        return valid;
    }

    itemFieldChanged = (e, overrideValue) => {
        let fieldName = e.target.name;
        let value = overrideValue === undefined ? e.target.value : overrideValue;
        this.setState(prvState => ({
            form: {
                ...prvState.form,
                [fieldName]: value
            }
        }));
    };

    render() {
        return <><Row>
            <Col sm={12}>
                <Form id={"password-form"} noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="currentPassword">
                            <Form.Label size="sm">
                                Current Password
                            </Form.Label>
                            <Form.Control required type={"password"} size="sm" name={"currentPassword"} value={this.state.currentPassword} onChange={this.itemFieldChanged}/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>&nbsp;</Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="newPassword1">
                            <Form.Label size="sm">
                                New Password
                            </Form.Label>
                            <Form.Control required type={"password"} size="sm" name={"newPassword1"} value={this.state.newPassword1} onChange={this.itemFieldChanged} pattern={"^\\S{8,64}$"}/>
                            <Feedback type={"invalid"}>Passwords must be 8-64 characters long, no spaces.</Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="newPassword2">
                            <Form.Label size="sm">
                                Confirm New Password
                            </Form.Label>
                            <Form.Control required type={"password"} size="sm" name={"newPassword2"} value={this.state.newPassword2} onChange={this.itemFieldChanged} pattern={"^\\S{8,64}$"}/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <div className={"text-center text-danger"}>{nlToBr(this.state.errorMessage)}</div>
                        </Col>
                    </Form.Row>
                </Form>
            </Col>
        </Row>
        <Row className={"mt-4"}>
            <Col className={"text-right"}>
                <Button variant="secondary" onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button className={"ml-2"} variant="dark" onClick={this.handleSubmit}>
                    OK
                </Button>
            </Col>
        </Row>
    </>
    }
}